import { create, skipWhen } from "vest";

import { WARRANTY_SUBTYPE } from "constants/products";
import {
  COCHLEAR_IMPLANT_PRODUCT_TYPE,
  FEE_PRODUCT_TYPE,
  HEARING_AID_PRODUCT_TYPE,
  SERVICE_PRODUCT_TYPE,
  SUPPLY_PRODUCT_TYPE
} from "constants/sales";
import { maxLength, required } from "utils/validations.utils";

import { AddMasterProductFormValues } from "./add-master-product-form.component";

export type AddMasterProductFormFieldName =
  | "type"
  | "subtype"
  | "description"
  | "manufacturer"
  | "model"
  | "specification.warranty_months"
  | "specification.warranty_field"
  | "specification.color"
  | "specification.technology"
  | "specification.type";

export const formValidator = () =>
  create((data: AddMasterProductFormValues) => {
    const { type, subtype, description, manufacturer, model, specification } =
      data;

    required<AddMasterProductFormFieldName>("type", "Type", type);

    if (Number(type) === HEARING_AID_PRODUCT_TYPE) {
      required<AddMasterProductFormFieldName>(
        "specification.type",
        "Type",
        specification?.type
      );

      required<AddMasterProductFormFieldName>(
        "specification.technology",
        "Technology",
        specification?.technology
      );
    }

    skipWhen(Number(subtype) !== WARRANTY_SUBTYPE, () => {
      required<AddMasterProductFormFieldName>(
        "specification.warranty_months",
        "Warranty Months",
        specification?.warranty_months
      );
      required<AddMasterProductFormFieldName>(
        "specification.warranty_field",
        "Warranty Type",
        specification?.warranty_field
      );
    });

    skipWhen(
      [
        HEARING_AID_PRODUCT_TYPE,
        SUPPLY_PRODUCT_TYPE,
        FEE_PRODUCT_TYPE,
        COCHLEAR_IMPLANT_PRODUCT_TYPE
      ].includes(Number(type)),
      () => {
        required<AddMasterProductFormFieldName>("subtype", "Subtype", subtype);
      }
    );

    skipWhen(
      (Number(type) !== SERVICE_PRODUCT_TYPE &&
        Number(type) !== FEE_PRODUCT_TYPE &&
        Number(type) !== SUPPLY_PRODUCT_TYPE) ||
        (Number(type) === SUPPLY_PRODUCT_TYPE &&
          Boolean(manufacturer?.id) &&
          Boolean(model)),
      () => {
        required<AddMasterProductFormFieldName>(
          "description",
          "Description",
          description
        );
      }
    );

    skipWhen(
      Number(type) === SERVICE_PRODUCT_TYPE ||
        Number(type) === FEE_PRODUCT_TYPE ||
        Number(type) === SUPPLY_PRODUCT_TYPE,
      () => {
        required<AddMasterProductFormFieldName>(
          "manufacturer",
          "Manufacturer",
          manufacturer
        );
        required<AddMasterProductFormFieldName>("model", "Model", model);
      }
    );

    skipWhen(!model, () => {
      maxLength<AddMasterProductFormFieldName>("model", "Model", model, 64);
    });
  });
